/**
 * fromQr 自動起動（detail.tsx ①）の判定（#3649）。
 *
 * 外部カメラ QR / アプリ内スキャナーから `fromQr` 付きで遷移してきたときに、
 * スタンプフローを自動で始めてよいか・待つべきか・起動せずに終えるべきかを決める。
 * 副作用（send / router.replace / ダイアログ）は呼び出し側で行う。
 */

export type FromQrAutoStartAction = 'wait' | 'start' | 'skipOutOfPeriod' | 'skipPurchaseLocked'

export type FromQrAutoStartInput = {
  /** lifecycle が appReady / showingConfirm に到達済みか（会員登録時アンケートの表示判定が済んでいるか） */
  isQuestionnaireSettled: boolean
  /** stampFlow が idle か */
  isStampIdle: boolean
  /** /api/v2/sheets 取得中か（購入連動ロックが未確定） */
  isSheetsPending: boolean
  isOutOfPlayingPeriod: boolean
  purchaseLocked: boolean
}

/**
 * 判定順: lifecycle → stampFlow → sheets → 期間外 → 購入連動ロック。
 *
 * - lifecycle を先頭に置くのは、アンケートダイアログの裏で押印 API を呼ばないため、
 *   および購入連動ロックの注意喚起ダイアログをアンケートと重ねないため。
 * - 期間外は購入しても解消しないため、購入連動ロックより優先する
 *   （detail.tsx の purchaseLocked は期間外を除外して定義されているが、関数単体でも同じ前提が成り立つようにする）。
 */
export const resolveFromQrAutoStartAction = (input: FromQrAutoStartInput): FromQrAutoStartAction => {
  if (!input.isQuestionnaireSettled) return 'wait'
  if (!input.isStampIdle) return 'wait'
  if (input.isSheetsPending) return 'wait'
  if (input.isOutOfPlayingPeriod) return 'skipOutOfPeriod'
  if (input.purchaseLocked) return 'skipPurchaseLocked'
  return 'start'
}
